/**
 * Labstep
 *
 * @module core/SubHeader
 * @desc To be used for Tabs / Breadcrumbs
 */

import cx from 'classnames';
import React from 'react';
import styles from './styles.module.scss';
import type { ISubHeaderProps } from './types';

export const SubHeader: RFC<ISubHeaderProps> = ({
  children,
  className,
  style,
}) => {
  const classes = cx(styles.subHeader, className);

  return (
    <span style={style} className={classes} data-public>
      {children}
    </span>
  );
};
